import {BaseDomainModel} from "../../../infrastructure/models/base-domain-model";
import {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";
import {CompetitorDomainModel} from "../../common/competitor/models/competitor-domain-model";
import {PartialGameDomainModel} from "../../partial-game/models/partial-game-domain-model";
import {AthleteDomainModel} from "../../common/athlete/athlete-domain-model";
import {BaseApiRequestModel} from "../../../infrastructure/models/base-api-request-model";
import {BaseDomainDataSource} from "../../../infrastructure/models/base-domain-data-source";

export class EntitiesResponseDomainModel extends BaseDomainDataSource {
  entities: Array<BaseDomainModel> = [];
  competitions: Array<CompetitionDomainModel>;
  competitors: Array<CompetitorDomainModel>;
  games: Array<PartialGameDomainModel>;
  athletes: Array<AthleteDomainModel>;
  request: BaseApiRequestModel;

  constructor(
    competitions: Array<CompetitionDomainModel>,
    competitors: Array<CompetitorDomainModel>,
    games: Array<PartialGameDomainModel>,
    athletes: Array<AthleteDomainModel>,
    request: BaseApiRequestModel
  ) {
    super({request});

    this.entities.push(...competitions);
    this.entities.push(...competitors);
    this.entities.push(...games);
    this.entities.push(...athletes);

    this.competitions = competitions;
    this.competitors = competitors;
    this.games = games;
    this.athletes = athletes;
  }
}
